import React, { useState, useEffect } from 'react';
import { 
    Container, Row, Col, Card, CardHeader, CardBody, 
    Table, Input, Spinner 
} from 'reactstrap';
import moment from 'moment';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BreadCrumb from '../../Components/Common/BreadCrumb';

const API_BASE_URL = process.env.REACT_APP_API_URL?.replace(/\/$/, '');

const SmsLogs = () => {
    useEffect(() => {
        document.title = "SMS Logs";
    }, []);
    
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [pagination, setPagination] = useState({
        currentPage: 1,
        limit: 10,
        totalCount: 0
    });

    const fetchLogs = async (page = 1) => {
        try {
            setLoading(true);
            const skip = (page - 1) * pagination.limit;
            let url = `${API_BASE_URL}/smsLogs?skip=${skip}&limit=${pagination.limit}`;
            
            if (searchText) {
                url += `&searchText=${encodeURIComponent(searchText)}`;
            }
            
            const response = await fetch(url, {
                headers: {
                    'Authorization': JSON.parse(sessionStorage.getItem("authUser"))?.token || '',
                }
            });

            const data = await response.json();
            
            if (data.data) {
                setLogs(data.data);
                setPagination(prev => ({
                    ...prev,
                    currentPage: page,
                    totalCount: data.recordsTotal
                }));
            }
        } catch (error) {
            toast.error(error.message || 'Failed to fetch SMS logs', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
            console.error('Error fetching SMS logs:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            fetchLogs(1);
        }, 300);

        return () => clearTimeout(debounceTimer);
    }, [searchText]);

    return (
        <React.Fragment>
        <div className="page-content">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
            
            <Container fluid>
                    <BreadCrumb title="SMS Logs" pageTitle="Logs" />
                <Row>
                    <Col lg={12}>
                        <Card>
                                <CardHeader className="border-bottom-dashed">
                                    <Row className="g-3">
                                        <Col xxl={3} lg={6}>
                                            <div className="search-box">
                                                <Input 
                                                    type="text"
                                                    className="form-control search"
                                                    placeholder="Search by username..."
                                                    value={searchText}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                    </Row>
                            </CardHeader>
                            <CardBody>
                                <div className="table-responsive">
                                    <Table className="table-striped table-nowrap align-middle mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                    <th style={{ width: '80px' }}>Sl. No</th>
                                                    <th>Date & Time</th>
                                                    <th>Username</th>
                                                    <th>Trigger</th>
                                                    <th>Phone Number</th>
                                                    <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                                {logs.map((log, index) => (
                                                <tr key={log._id}>
                                                        <td>
                                                            {((pagination.currentPage - 1) * pagination.limit) + index + 1}
                                                        </td>
                                                        <td>{moment.unix(log.createDate).format('DD MMM YYYY, hh:mm A')}</td>
                                                        <td>{log.userName || 'N/A'}</td>
                                                    <td>
                                                        <span className={`badge bg-${
                                                                log.trigger === 'LOGIN' ? 'info' :
                                                                log.trigger === 'REGISTER' ? 'success' :
                                                                'warning'
                                                            }-subtle text-${
                                                                log.trigger === 'LOGIN' ? 'info' :
                                                                log.trigger === 'REGISTER' ? 'success' :
                                                            'warning'
                                                        }`}>
                                                                {log.trigger}
                                                        </span>
                                                    </td>
                                                        <td>{log.to}</td>
                                                        <td>
                                                            <span className={`badge bg-${log.status === 'pending' ? 'warning' : 'success'}-subtle text-${log.status === 'pending' ? 'warning' : 'success'}`}>
                                                                {log.status}
                                                            </span>
                                                    </td>
                                                </tr>
                                            ))}
                                                {logs.length === 0 && (
                                                    <tr>
                                                        <td colSpan="6" className="text-center py-4 text-muted">
                                                            <i className="ri-information-line fs-4 me-1 align-middle"></i>
                                                            No SMS logs found
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </Table>
                                </div>
                                    {logs.length > 0 && renderPagination()}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            </div>
            {loading && (
                <div className="overlay">
                    <div className="spinner-container">
                        <Spinner color="primary" />
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default SmsLogs;